import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';

import {
  getMultipleChoiceFilterOptions,
  getSelectedOptionIdsString,
} from 'src/utils/filtersUtils';
import { getFiltersName } from 'src/routes/SearchPage/controllers/getFilterName';
import { getFiltersFromUrl } from '../utils';
import { getDestinationCountryNameForm2 } from './searchParams';

// TODO: LT-27333 - вынести серекторы фильтров в общие компоненты
// и проверить что FilterRating не вызывает циклическую зависимость
import { getFilter, getFilters, getPlainFilters } from './filtersBase';

export { getFilter, getFilters, getPlainFilters };

export const getMinPrice = (state): number | null => {
  const prices = getFilter(state, 'prices');
  return prices ? prices.get('min') : null;
};

const getHotelFilter = (state) => getFilter(state, 'hotel_name');
export const getHotelFilterValue = createSelector(getHotelFilter, (filter) =>
  filter?.get('value'),
);

export const getOfferFilters = createSelector(getPlainFilters, (filters) => {
  const ltExtras = getMultipleChoiceFilterOptions(filters, 'lt_extras');
  const operators = getMultipleChoiceFilterOptions(filters, 'operators');
  const freeCancel = get(filters, ['free_cancel', '0', 'selected']);
  const directFlight = get(filters, ['direct_flight', '0', 'selected']);
  const meals = getMultipleChoiceFilterOptions(filters, 'meals');
  const paymentBenefits = getMultipleChoiceFilterOptions(
    filters,
    'payment_benefits',
  );
  const travelBenefits = getMultipleChoiceFilterOptions(
    filters,
    'travel_benefits',
  );

  const hotelBenefits = getMultipleChoiceFilterOptions(
    filters,
    'hotel_benefits',
  );

  /**
   * confirmability – расширенная версия фильтра instant_confirm
   * Имеет три положения: Моментальное подтверждение/Быстрое подтверждение/Все туры
   */
  const confirmabilityFilters = get(filters, ['confirmability']);
  const confirmability = getSelectedOptionIdsString(confirmabilityFilters);

  return {
    confirmability,
    freeCancel,
    directFlight,
    operators: getSelectedOptionIdsString(operators),
    ltExtras: getSelectedOptionIdsString(ltExtras),
    meals: getSelectedOptionIdsString(meals),
    paymentBenefits: getSelectedOptionIdsString(paymentBenefits),
    travelBenefits: getSelectedOptionIdsString(travelBenefits),
    hotelBenefits: getSelectedOptionIdsString(hotelBenefits),
  };
});

export const getFilterRegions = createSelector(
  getPlainFilters,
  getDestinationCountryNameForm2,
  ({ regions }, country) => {
    if (!regions) return null;
    const minPrice = Math.min(...regions.map(({ min_price }) => min_price));
    return [
      { id: 0, name: `Все регионы\n ${country}`, min_price: minPrice },
      ...regions.sort((i, j) => (i.name || '').localeCompare(j.name || '')),
    ];
  },
);

export const activeFiltersSelector = createSelector(
  getPlainFilters,
  (filtersData) => {
    // собираем активные фильтры из url
    const activeFiltersName = Object.keys(getFiltersFromUrl());

    // находим данные активных фильтров
    const activeFilters = Object.entries(filtersData).filter(([key]) => {
      if (key === 'prices') {
        return ['filter_price_min', 'filter_price_max'].some(
          (name) => activeFiltersName.indexOf(name) !== -1,
        );
      }
      return activeFiltersName.indexOf(`filter_${key}`) !== -1;
    });

    return getFiltersName(activeFilters);
  },
);
